import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Pipe({
    name: 'hasRole',
    standalone: false
})
export class HasRolePipe implements PipeTransform {
  constructor(private authService: AuthService) { }

  public transform(allowedRoles: string[]): Observable<boolean> {
    return this.authService.userRole$.pipe(
      filter(role => role !== null),
      take(1),
      map(role => {
        if (role && role && allowedRoles && allowedRoles.indexOf(role) > -1) {
          return true;
        } else {
          return false;
        }
      })
    );
  }
}
